// Branding template presets for different organization types
export const BRANDING_TEMPLATES = [
  {
    id: "church-classic",
    name: "Church Classic",
    category: "church",
    description: "Traditional church branding with subtle, elegant styling",
    preview_bg: "from-slate-900 to-slate-800",
    settings: {
      branding_logo_position: "bottom-right",
      branding_logo_size: "small",
      branding_logo_opacity: 0.7,
      branding_text_position: "bottom-center"
    },
    sample_text: "Faith Community Church"
  },
  {
    id: "church-modern",
    name: "Church Modern",
    category: "church",
    description: "Contemporary church style with bold positioning",
    preview_bg: "from-indigo-900 to-purple-900",
    settings: {
      branding_logo_position: "top-left",
      branding_logo_size: "medium",
      branding_logo_opacity: 0.85,
      branding_text_position: "bottom-right"
    },
    sample_text: "New Life Church"
  },
  {
    id: "school-academic",
    name: "School Academic",
    category: "school",
    description: "Professional academic style for schools",
    preview_bg: "from-blue-900 to-blue-800",
    settings: {
      branding_logo_position: "top-right",
      branding_logo_size: "medium",
      branding_logo_opacity: 0.8,
      branding_text_position: "bottom-center"
    },
    sample_text: "Springfield Academy"
  },
  {
    id: "school-playful",
    name: "School Playful",
    category: "school",
    description: "Fun and engaging style for younger audiences",
    preview_bg: "from-green-800 to-teal-800",
    settings: {
      branding_logo_position: "top-left",
      branding_logo_size: "large",
      branding_logo_opacity: 0.9,
      branding_text_position: "bottom-left"
    },
    sample_text: "Sunshine Elementary"
  },
  {
    id: "corporate-minimal",
    name: "Corporate Minimal",
    category: "corporate",
    description: "Clean, professional corporate style",
    preview_bg: "from-gray-900 to-gray-800",
    settings: {
      branding_logo_position: "bottom-right",
      branding_logo_size: "small",
      branding_logo_opacity: 0.6,
      branding_text_position: "bottom-right"
    },
    sample_text: "Acme Corporation"
  },
  {
    id: "corporate-bold",
    name: "Corporate Bold",
    category: "corporate",
    description: "High-impact corporate branding",
    preview_bg: "from-slate-800 to-zinc-900",
    settings: {
      branding_logo_position: "top-left",
      branding_logo_size: "large",
      branding_logo_opacity: 0.95,
      branding_text_position: "bottom-center"
    },
    sample_text: "Global Industries"
  },
  {
    id: "ministry-worship",
    name: "Ministry Worship",
    category: "ministry",
    description: "Perfect for worship and music ministries",
    preview_bg: "from-purple-900 to-pink-900",
    settings: {
      branding_logo_position: "bottom-left",
      branding_logo_size: "small",
      branding_logo_opacity: 0.75,
      branding_text_position: "bottom-center"
    },
    sample_text: "Worship Ministry"
  },
  {
    id: "ministry-youth",
    name: "Ministry Youth",
    category: "ministry",
    description: "Energetic style for youth groups",
    preview_bg: "from-orange-800 to-red-900",
    settings: {
      branding_logo_position: "top-right",
      branding_logo_size: "medium",
      branding_logo_opacity: 0.85,
      branding_text_position: "bottom-right"
    },
    sample_text: "Youth Group"
  },
  {
    id: "event-conference",
    name: "Event Conference",
    category: "event",
    description: "Professional conference and event branding",
    preview_bg: "from-cyan-900 to-blue-900",
    settings: {
      branding_logo_position: "top-left",
      branding_logo_size: "medium",
      branding_logo_opacity: 0.8,
      branding_text_position: "bottom-center"
    },
    sample_text: "Annual Conference 2026"
  },
  {
    id: "personal-speaker",
    name: "Personal Speaker",
    category: "personal",
    description: "For individual speakers and presenters",
    preview_bg: "from-amber-900 to-orange-900",
    settings: {
      branding_logo_position: "bottom-right",
      branding_logo_size: "small",
      branding_logo_opacity: 0.7,
      branding_text_position: "bottom-right"
    },
    sample_text: "John Smith, Speaker"
  },
  {
    id: "clean-subtle",
    name: "Clean & Subtle",
    category: "minimal",
    description: "Minimalist branding that doesn't distract",
    preview_bg: "from-neutral-900 to-neutral-800",
    settings: {
      branding_logo_position: "bottom-right",
      branding_logo_size: "small",
      branding_logo_opacity: 0.5,
      branding_text_position: "bottom-right"
    },
    sample_text: ""
  },
  {
    id: "no-branding",
    name: "No Branding",
    category: "minimal",
    description: "Remove all branding elements",
    preview_bg: "from-slate-900 to-slate-800",
    settings: {
      branding_enabled: false,
      branding_logo_url: "",
      branding_text: "",
      branding_logo_position: "bottom-right",
      branding_logo_size: "small",
      branding_logo_opacity: 0.8
    },
    sample_text: ""
  }
];

export const TEMPLATE_CATEGORIES = [
  { id: "all", name: "All Templates", icon: "Grid" },
  { id: "church", name: "Church", icon: "Church" },
  { id: "school", name: "School", icon: "GraduationCap" },
  { id: "corporate", name: "Corporate", icon: "Briefcase" },
  { id: "ministry", name: "Ministry", icon: "Heart" },
  { id: "event", name: "Event", icon: "Calendar" },
  { id: "personal", name: "Personal", icon: "User" },
  { id: "minimal", name: "Minimal", icon: "Minus" }
];
